import { render, staticRenderFns } from "./Binding.vue?vue&type=template&id=e454e91e&scoped=true&"
import script from "./Binding.vue?vue&type=script&lang=js&"
export * from "./Binding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e454e91e",
  null
  
)

export default component.exports